import { motion } from "framer-motion";

const Testimonial = () => {
  return (
    <section className="bg-background">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="overflow-hidden"
        >
          <img
            src="/gallery/love_otherwise-105.jpg"
            alt="A & K's Wedding at Love Otherwise"
            className="w-full h-[500px] lg:min-h-[600px] object-cover"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col justify-center px-8 lg:px-16 py-24 lg:py-32"
        >
          <div className="flex items-center gap-4">
            <div className="overflow-hidden w-16 h-16 rounded-full shrink-0">
              <img
                src="/testimonial/couple.webp"
                alt="A & K"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-xs tracking-[0.3em] uppercase text-warm-gray font-body">A & K's Wedding</span>
          </div>
          <div className="mt-6">
            <svg className="w-8 h-8 text-champagne mb-4" viewBox="0 0 24 24" fill="currentColor">
              <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311C9.591 11.68 11 13.135 11 15c0 1.933-1.567 3.5-3.5 3.5-1.152 0-2.237-.544-2.917-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311C19.591 11.68 21 13.135 21 15c0 1.933-1.567 3.5-3.5 3.5-1.152 0-2.237-.544-2.917-1.179z"/>
            </svg>
            <blockquote className="text-lg md:text-xl font-serif italic leading-relaxed text-foreground">
              <strong>Magical from the very first moment.</strong> As soon as I walked into the venue, I could feel the magic and love in the space. It was absolutely perfect for our wedding. You can see the care and dedication that went into restoring it. Angie's incredible taste and style shine through in every corner.
            </blockquote>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonial;
